import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "src/app/truck-owner/truck-owner.service";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-trips-edit-credit-trips",
  templateUrl: "./admin-trips-edit-credit-trips.component.html",
  styleUrls: ["./admin-trips-edit-credit-trips.component.css"],
})
export class AdminTripsEditCreditTripsComponent implements OnInit {
  editCreditForm: FormGroup;
  token: any;

  constructor(
    private matdialogref: MatDialogRef<AdminTripsEditCreditTripsComponent>,
    private formbuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.editCreditForm = this.formbuilder.group({
      truck_number: [""],
      driverName: [""],
      mobile: [""],
      loading_point: [""],
      unloading_point: [""],
      price_per_ton: [""],
      sales_order_number: [""],
      lr_number: [""],
      lr_date: [""],
      tax_invoice_no: [""],
      ddc_no: [""],
    });

    this.editCreditForm.patchValue({
      truck_number: this.data.truckInfo[0]?.truck_number,
      driverName: this.data.driverInfo[0]?.username,
      mobile: this.data.driverInfo[0]?.mobile,
      loading_point: this.data.workOrderOtherDetails?.loading_point,
      unloading_point: this.data.workOrderOtherDetails?.unloading_point,
      price_per_ton:
        (this.data.workOrderOtherDetails?.price_per_ton).toFixed(2),
      sales_order_number: this.data.workOrderOtherDetails?.sales_order_number,
      lr_number: this.data.workOrderOtherDetails?.lr_number,
      lr_date: this.data.workOrderOtherDetails?.lr_date,
      tax_invoice_no: this.data.workOrderOtherDetails?.tax_invoice_no,
      ddc_no: this.data.workOrderOtherDetails?.ddc_no,
    });
  }
  close() {
    this.matdialogref.close();
  }
  updateTrip() {
    let unloading = this.editCreditForm.value.unloading_point;
    if (!unloading) {
      this.snackBar.open("Please enter unloading point", "Fail", {
        duration: 5000,
      });
    }
    const updateTrip = {
      unLoadedQuantity: Number(this.editCreditForm.value.unloading_point),
    };
    this.services
      .tripUpdate(this.data._id, this.token, updateTrip.unLoadedQuantity)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matdialogref.close();
            this.snackBar.open(
              "Updated unLoaded point successfully",
              "Success",
              {
                duration: 5000,
              }
            );
            window.location.reload();
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
